export default __webpack_public_path__ + "static/Graphik-RegularItalic-Cy-Web-c2f7829813e3de3178b0eff5ad6187f5.woff";